module.exports = __webpack_public_path__ + "images/MyCarda8b565f9007cb0dcb130483e9439fe7b.jpg";